<template lang="html">
    <div class="full-container">
        <!-- create, edit, add comment or request -->

        <!-- #region Toolbar -->
        <!-- toolbar of the modal -->
        <div class="modal-header">
            <div class="app-logo">
                <img src="../../../assets/img/logo_s_pink.svg" />
            </div>

            <v-btn flat @click.native="onClose" :disabled="editedElement && editedElement.id != null">
                <v-icon>arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title >{{product_name}}</v-toolbar-title>
        </div>
        <!-- #endregion -->

        <!-- #region Comments Aside -->
        <!-- aside menu, with tab (comments & requests) and all elems inside -->
        <div class="comments-aside">
            <div class="tab">
                <!-- can only click if there is not element in edition -->
                <v-tabs grow v-model="selectedPage" slider-color="primary" :show-arrows="true">
                    <v-tab color="primary" :href="editedElement && editedElement.id != null ? '' :'#requests'" @click="goTo('requests')" ripple v-if="show_demand == true" :disabled="editedElement.id != null ? true : false">Demandes</v-tab>
                    <v-tab color="primary" :href="editedElement && editedElement.id != null ? '' :'#comments'" @click="goTo('comments')" ripple :disabled="editedElement.id != null ? true : false">Commentaires</v-tab>
                </v-tabs>
                    <div column class="scroll-y draggable-container" id="scroll-target" >
                        <!-- can drag & drop elements, update the position of each -->
                        <draggable v-model="items" element="ul"  :options="dragOptions" @start="isDragging=true" @end="onMove"
                        v-scroll="{target: '#scroll-target'}">
                            <transition-group type="transition" :name="'flip-list'" class="drag_container">
                                <li v-for="(element,index) in items" :key="index" class="item" >
                                    <a @click="selectItem(element, index)" >
                                        <v-layout :class="{'current-item': element.id === selectedId,'item-draggable':true}" justify-space-around align-content-space-around>
                                            <div class="item-draggable-avatar">
                                                <v-flex class="item-draggable-position">{{element.position}}</v-flex>
                                                <avatar class="item-draggable-image" :item="element.user" size="5rem" v-if="element.type != 'separator'"></avatar>
                                                <v-avatar class="grey lighten-2" style="marginBottom:2px" size="5rem" v-else><v-icon>title</v-icon></v-avatar>
                                                <template v-if="selectedPage !== 'requests'">
                                                    <v-icon v-if="editedElement.id !== element.id" class="aside-type-color-round" :style="{color: getCommentColor(element.type)}">fiber_manual_record</v-icon>
                                                    <v-icon v-else class="aside-type-color-round" style="{color:none}">fiber_manual_record</v-icon>
                                                </template>
                                            </div>
                                            <v-layout column justify-space-around align-content-space-around class="item-draggable-text">
                                                <v-flex class="item-draggable-title" :class="{'bold': element.type == 'separator'}">
                                                    {{element.title}}
                                                </v-flex>
                                                <v-flex class="item-draggable-user" v-if="element.type != 'separator'">par {{element.user.first_name}} {{element.user.last_name}}</v-flex>
                                                <div class="item-draggable-date">
                                                    <pre class="item-draggable-line" v-if="element.type != 'separator'">  </pre>Le {{moment(element.updated_at).format('DD/MM/YYYY')}}
                                                </div>
                                            </v-layout>
                                            <div class="item-draggable-action">
                                                <v-icon @click.stop="moveUp(element)">keyboard_arrow_up</v-icon>
                                                <v-icon @click.stop="moveDown(element)">keyboard_arrow_down</v-icon>
                                            </div>
                                        </v-layout>
                                    </a>
                                    <v-divider></v-divider>
                                </li>
                            </transition-group>
                        </draggable>
                    </div>
                    <!-- footer menu, add element  -->
                    <v-layout justify-center align-center class="add-footer">
                            <v-btn @click="clickAdd" :disabled="editedElement && editedElement.id != null" class="menu-button" :class="{ active: isMenuOpen }">
                                Ajouter
                                <v-icon>mode_edit</v-icon>
                            </v-btn>
                            <div v-if="isMenuOpen" column class="add-menu">
                                <v-flex class="add-menu-item">
                                    <v-btn @click="addNewItem()" class="menu-button">
                                        <v-icon>add</v-icon>
                                        <span>Nouvel Element</span>
                                    </v-btn>
                                </v-flex>
                                <v-divider></v-divider>
                                <v-flex class="add-menu-item">
                                    <v-btn @click="addItemFromSymbol()" class="menu-button">
                                        <v-icon>autorenew</v-icon>
                                        <span>Symbole</span>
                                    </v-btn>
                                </v-flex>
                                <v-divider></v-divider>
                                <v-flex class="add-menu-item">
                                    <v-btn @click="addNewItem('separator')" class="menu-button">
                                        <v-icon>title</v-icon>
                                        <span>Titre</span>
                                    </v-btn>
                                </v-flex>
                                <v-divider></v-divider>
                            </div>
                    </v-layout>
                </v-tabs>
            </div>
        </div>
        <!-- #endregion -->

        <!-- #region Content -->
        <!-- content -- edition or reading -->
        <div :class="{'is-editing':(!editedElement || editedElement.id) !== null ,'comments-contents':true ,'scroll-y':true}" id="scroll-container">
            <div v-scroll="{target: '#scroll-container'}" v-for="(element,index) in items" :key="index" class="content-item"  :id="'element-'+index" row wrap>
                <div class="full-element-container" v-touch:swipe="swipeEvent" v-on:mouseover="mouseOverElement(element, index)">
                    <v-alert :value="true" outline color="warning" icon="warning" v-show="(!editedElement || editedElement.id) !== null" transition="scale-transition">
                      L'élèment est en cours d'édition, enregistrer ou annuler pour continuer
                    </v-alert>
                    <v-flex xs12 class="content-toolbar">
                            <avatar class="item-draggable-avatar" :item="element.user" size="5rem"></avatar>
                            <template v-if="selectedPage !== 'requests'">
                                <v-icon v-if="editedElement.id !== element.id" class="type-color-round" :style="{color: getCommentColor(element.type)}">fiber_manual_record</v-icon>
                                <v-icon v-else class="type-color-round" style="{color: none}">fiber_manual_record</v-icon>
                            </template>
                            <div class="user-name-container">
                                {{element.user.first_name}} {{element.user.last_name}}
                                <div class="writing-mode">
                                    {{getWritingMode(element)}}
                                </div>
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn v-if="editedElement.id === element.id" round small flat :color="'primary'" @click="unsetEditedElement()">Annuler</v-btn>
                            <v-btn v-if="element.id !== 0 && ($store.state.auth.user.level >= 60 || element.user_id == $store.state.auth.user.id) " round small flat :color="'primary'" @click="confirmRemove = true">Supprimer</v-btn>

                            <div class="contain-type-select" v-if="editedElement.id === element.id && selectedPage !== 'requests'">
                                <v-select
                                v-model="editedElement.type"
                                :items="commentTypes"
                                item-value="value"
                                >
                                    <template slot="selection" slot-scope="data">
                                          <v-icon :style="{color: data.item.color}">fiber_manual_record</v-icon>
                                            {{ data.item.label }}
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <template v-if="typeof data.item === 'object'">
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                  <v-icon :style="{color: data.item.color}">fiber_manual_record</v-icon>
                                                  {{ data.item.label }}
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                        </template>
                                    </template>
                                </v-select>
                            </div>
                            <v-btn v-if="editedElement.id !== element.id && ($store.state.auth.user.level >= 60 || element.user_id == $store.state.auth.user.id)" round depressed small :color="'primary'" @click="setEditedElement(element)" >{{editLabel(element)}}</v-btn>
                            <v-btn v-if="editedElement.id === element.id && editedElement.type != 'separator'"  outline round depressed small :color="'primary'" :loading="loading_file" @click="saveElement(editedElement,true)" >Ajouter une pièce jointe</v-btn>
                            <v-btn v-if="editedElement.id === element.id" round depressed small :color="'primary'" @click="saveElement(editedElement)">Enregistrer</v-btn>
                    </v-flex>
                    <div class="loader" v-if="loading">
                        <img src="../../../assets/img/grid_loader.svg" />
                    </div>
                    <div class="center-content" :class="[nb_column == 2 ? 'doublecol' : '']" v-if="!loading">
                        <v-form v-model="valid_title" v-if="editedElement.id === element.id">
                            <v-layout row class="title-row">
                                <v-flex :xs12="isCol(1)" :md6="isCol(2)" :sm12="isCol(2)" class="edit-title">
                                    <v-text-field
                                    name='titre1_text_field'
                                    label='Titre'
                                    hint='Titre de votre commentaire'
                                    v-model="editedElement.title"
                                    :rules="rules.title"
                                    required
                                    :error="isTitleError()"
                                    autocomplete="off"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex v-if="isCol(2) && editedElement.type != 'separator'" md6 sm12 class="edit-title">
                                    <v-text-field
                                    name='titre2_text_field'
                                    label='Titre 2'
                                    :hint="hint_title2"
                                    :persistent-hint="error_2"
                                    :error="error_2"
                                    :rules="rules.title_2"
                                    v-model="editedElement.title_2"
                                    autocomplete="off"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>

                        <v-layout row v-else class="read">
                            <v-flex :xs12="isCol(1)" :md6="isCol(2)" :sm12="isCol(2)">
                                <div class="comment-title on-left">
                                    {{element.title}}
                                </div>
                            </v-flex>
                            <v-flex v-if="isCol(2) && element.type != 'separator'" sm12 md6>
                                <div class="comment-title on-right">
                                    {{element.title_2}}
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-form v-model="valid_message" v-if="editedElement.id === element.id && element.type != 'separator'">
                            <v-layout row>
                                <v-flex :xs12="isCol(1)" :md6="isCol(2)" :sm12="isCol(2)" class="edit-message">
                                    <v-text-field
                                    name='message_text_field'
                                    label='Message'
                                    hint='Contenu du message'
                                    v-model="editedElement.message"
                                    multi-line
                                    :error="isMessageError()"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex v-if="isCol(2)" sm12 md6 class="edit-message">
                                    <v-text-field
                                    name='message_text_field2'
                                    label='Message 2'
                                    :hint="hint_message2"
                                    v-model="editedElement.message_2"
                                    :persistent-hint="error_2"
                                    :error="error_2"
                                    multi-line
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                        <v-layout row v-else class="read">
                            <v-flex :xs12="isCol(1)" :md6="isCol(2)" :sm12="isCol(2)">
                                <p class="comment-message on-left scroll-y">
                                    <span v-html="$options.filters.nl2br(element.message)"></span>
                                    <!-- {{element.message}} -->
                                </p>
                            </v-flex>
                            <v-flex v-if="isCol(2) && element.type != 'separator'" sm12 md6>
                                <p class="comment-message on-right scroll-y">
                                    <span v-html="$options.filters.nl2br(element.message_2)"></span>
                                    <!-- {{element.message_2}} -->
                                </p>
                            </v-flex>
                        </v-layout>

                        <!-- #region -- images -->
                        <div class="d-flex imgs" v-if="display && element.type != 'separator'">
                            <v-flex :class="nb_column == 2 ? 'sm12 md6' : 'xs12'" v-for="(col,i) in nb_column" :key="i">
                                <v-layout wrap class="img-layout">
                                    <div class="mr-5" v-for="(file,index) in element.files" :key="file.id" @click="editedElement.id !== element.id && openImg(file)" v-if="file.pivot && file.pivot.file_type == null && file.pivot.location == 'area-'+col || file.pivot && file.pivot.file_type == 'null' && file.pivot.location == 'area-'+col">
                                        <v-menu offset-y content-class="files">
                                            <div slot="activator">
                                                <label class="comment-image">
                                                    <v-icon v-if="editedElement.id === element.id" class="hover-alpha">mode_edit</v-icon>
                                                    <img :src="file.path"/>
                                                </label>
                                            </div>
                                           <v-list v-if="editedElement.id === element.id">
                                               <v-list-tile>
                                                   <label :for="'file-'+index">Modifier l'image</label>
                                                   <input type="file" style="display:none" :id="'file-'+index" @change="(event)=>{onFileChange(event,element.id,index,col)}"/>
                                               </v-list-tile>
                                               <v-list-tile @click="$refs.deletefile.open(selectedPage,file,element.id)">
                                                   <v-list-tile-title>Supprimer l'image</v-list-tile-title>
                                               </v-list-tile>
                                           </v-list>
                                        </v-menu>
                                    </div>

                                    <div v-if="element.files.filter(f => f.pivot.location == 'area-'+col).length < 2 && editedElement.id === element.id">
                                        <v-menu offset-y content-class="files">
                                            <div slot="activator">
                                                <label class="comment-image">
                                                    <img :src="addImgPath()" class="add-img"/>
                                                </label>
                                            </div>
                                            <v-list v-if="editedElement.id === element.id">
                                                <v-list-tile>
                                                    <label :for="'input-'+col">Ajouter une image</label>
                                                    <input class="input-img" :id="'input-'+col" style="display:none" type="file" @change="(event)=>{onFileChange(event,element.id)}"/>
                                                </v-list-tile>
                                            </v-list>
                                         </v-menu>
                                    </div>
                                </v-layout>
                            </v-flex>
                        </div>
                        <!-- #endregion -->

                        <!-- #region -- files -->
                        <template v-for="(file,index) in element.files" v-if="file.pivot && file.pivot.file_type == 'attachment' && display">
                            <div class='files-list-container' @click="viewFile(file,element.files)">
                                <div class="files-list-container-title">
                                    Pièces jointes :
                                </div>
                                <template>{{file.label}}.{{file.type}}</template>
                                <v-spacer></v-spacer>
                                <v-btn icon v-if="editedElement.id === element.id" @click.stop="$refs.deletefile.open(selectedPage,file,element.id)">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <!-- #endregion -->

                    </div>
                </div>
                <!-- #region -- display -->
                <div v-if="editedElement.id === element.id" class="column-display-choice">
                    <div class="col-choice-title">
                        Affichage :
                    </div>
                    <div class="column-display-buttons">
                        <div>
                            <div @click="setColumnNumber(1)" class="image-and-overlay-left">
                                <img src="../../../assets/img/full.svg" class="col-chose-image"/>
                                <div v-if="nb_column === 1" class="col-choice-overlay"></div>
                            </div>
                        </div>
                        <div>
                            <div @click="setColumnNumber(2)" class="image-and-overlay-right">
                                <img src="../../../assets/img/split.svg" class="col-chose-image"/>
                                <div v-if="nb_column === 2" class="col-choice-overlay"></div>
                            </div>
                        </div>
                    </div>

                    <!-- #region -- confirm remove col modal -->
                    <v-dialog v-model="confirmRemove2" max-width="750px">
                        <v-card>
                            <v-card-title class="warning">
                                <h2>
                                    <v-icon dark class="mr-2">warning</v-icon>
                                    <span class="white--text">Attention</span>
                                </h2>
                                <v-spacer></v-spacer>
                                <v-btn small icon @click="confirmRemove2 = false">
                                    <v-icon dark>close</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-card-text>
                                Voulez vous vraiment supprimer la deuxième colonne ?
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn round small outline color="warning" @click.native="confirmRemove2 = false;">Annuler</v-btn>
                                <v-btn round depressed small color="warning" @click.native="deleteCol(element.id)">Valider</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <!-- #endregion -->

                </div>
                <!-- #endregion -->
            </div>
        </div>
        <!-- #endregion -->

        <!-- #region -- confirm remove modal -->
        <v-dialog v-model="confirmRemove" max-width="750px">
            <v-card>
                <v-card-title class="warning">
                    <h2>
                        <v-icon dark class="mr-2">warning</v-icon>
                        <span class="white--text">Attention</span>
                    </h2>
                    <v-spacer></v-spacer>
                    <v-btn small icon @click="confirmRemove = false">
                        <v-icon dark>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    Voulez vous vraiment supprimer {{selectedPage === 'requests' ? 'cette demande' : 'ce commentaire'}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn round small outline color="warning" @click.native="confirmRemove = false;">Annuler</v-btn>
                    <v-btn round depressed small color="warning" @click.native="deleteElement()">Valider</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- #endregion -->

        <!-- #region -- files -> create, delete -->
        <create-linked-files ref="modal" @added="function (entity_id,entity) { addFile(entity_id,entity) }"></create-linked-files>
        <delete-linked-file ref="deletefile" @deleted="function (entity_id,item_id) { deleteFile(entity_id,item_id) }"></delete-linked-file>
        <!-- #endregion -->
    </div>
</template>


<script>
import Avatar             from '../../../components/avatar/Avatar.vue'
import moment             from 'moment'
import draggable          from 'vuedraggable'
import { CommentTypes }   from '../../../config/enum/CommentTypes'
import ImportSymbol       from './ImportSymbol.vue'
import CreateLinkedFiles  from '../../../components/files/CreateLinkedFiles.vue'
import DeleteLinkedFile   from '../../../components/files/DeleteLinkedFiles.vue'
import Unlink             from './Unlink.vue'
import nl2br              from '../../../filters/nl2br'

export default {
    components: {
        draggable,
        Avatar,
        CreateLinkedFiles,
        DeleteLinkedFile
    },
    props: {
        params: {
            required: true,
        }
    },
    data() {
        return {
            moment,
            loading: false,
            imgFullPath :null,
            editedElement: {
                id: null,
                type: ''
            },
            isMenuOpen:false,
            selectedPage:'requests',
            selectedId:0,
            isDragging: false,
            isModalOpen: false,
            delayedDragging:false,
            comments:[],
            requests:[],
            product_name: '',
            valid_button: false,
            cancel_button: false,
            fullscreen: true,
            card_text_class: 'fullscreen-modal-text',
            nb_column: 1,
            activeTab: '',
            valid_title: false,
            valid_message: false,
            check_if_error: false,
            confirmRemove: false,
            confirmRemove2: false,
            show_demand: true,
            error_2: false,
            display:true,
            hint_title2: 'Titre du deuxième commentaire',
            hint_message2: 'Contenu du deuxième commentaire',
            loading_file:false,
            symbols: [],
            rules: {
                title: [
                    function(v){
                        if(v) {
                            if(v.length >= 150) {
                                return 'Le titre ne dois pas contenir plus de 150 caractères'
                            } else {
                                return true
                            }
                        } else {
                            return 'Titre obligatoire'
                        }
                    }
                ],
                title_2: [
                    function(v){
                        if(v) {
                            if(v.length >= 150) {
                                return 'Le titre ne dois pas contenir plus de 150 caractères'
                            } else {
                                return true
                            }
                        } else {
                            return true
                        }
                    }
                ]
            }
        }
    },

    computed:{
        items :{
            //get comments or requests in fonction of the selected tab
            get: function(){
                if (this.selectedPage === 'requests'){
                    return this.requests;
                } else {
                    return this.comments;
                }
            },
            set: function(value){
                if (this.selectedPage === 'requests'){
                    this.requests = value;
                } else {
                    this.comments = value;
                }
            }
        },
        // set the drag options
        dragOptions () {
            return  {
                animation: 200,
                sort: true,
                ghostClass: 'ghost',
                chosenClass: 'sortable-chosen',
            }
        },
        commentTypes: function() {
            return CommentTypes;
        },
    },

    methods: {
        // view attachment files
        viewFile(item,items){
            let attachment_items = items.filter(i => i.pivot.file_type == 'attachment')
            this.$eventHub.$emit('view-file',item,attachment_items)
        },
        // delete attachment files
        deleteFile(entity_id,item_id){
            this.display = false
            let index = this.items.findIndex((el)=>el.id === entity_id)
            let file_index = ''
            if(typeof item_id == 'number'){
                file_index = this.items[index].files.findIndex((el)=>el.id === item_id)
            } else {
                file_index = this.items[index].files.findIndex((el)=>el.path === item_id.path)
            }
            this.items[index].files.splice(file_index,1)
            this.display = true
        },
        // add attachment files
        addFile(entity_id,entity){
            this.display = false
            if(entity_id != 0) {
                let index = this.items.findIndex((el)=>el.id === entity_id)
                this.axios.get(`/api/${entity}?embed=files&filters=id|=|${entity_id}`)
                .then(response => {
                    this.items[index].files = response.data[0].files
                    this.loading_file = false
                    this.display = true
                })
            }
        },
        // open images in the viewer, create galery without attachment files
        openImg:function (file){
            let files = null
            this.items.forEach(i => {
                if(this.$_.find(i.files, f => f.id == file.id)) {
                    files = i.files
                }
            })
            this.$eventHub.$emit('view-file', file, files)
        },
        // get the color of the comment, positive, negative or neutral
        getCommentColor: function (type) {
          let commentType = CommentTypes.find((el) => {
            return el.value === type
          });
          return commentType ? commentType.color : '';
        },

        getWritingMode(element) {
            return (this.editedElement.id === element.id) ? 'Edition' : 'Lecture';
        },

        editLabel(element) {
            if(!!element.symbol_id && element.symbol_id!=='') {
                return "Editer le symbole"
            } else {
                return "Editer"
            }
        },
        // select an item
        selectItem(element, index){
            this.error_2 = false
            this.hint_message2 = ''
            this.hint_title2 = ''
            if (index >= 0){
                if (element && this.editedElement && this.editedElement.id !== null && element.id !== this.editedElement.id){
                    this.loading = false
                    console.log('there')
                    return;
                } else {
                    this.selectedId = element.id
                    element.title_2 || element.message_2 ? this.nb_column = 2 : this.nb_column = 1
                    // onclick on item, scroll to this one
                    this.$nextTick(() => {
                        if(document.getElementById('element-'+index)) {
                            document.getElementById('element-'+index).scrollIntoView();
                        }
                        this.loading = false
                    })
                }
            }
        },

        swipeEvent(){
            // for scroll with touch screen
            let _this = this
            //get the positon of the scroll
            let scrollTop = document.querySelector('#scroll-container').scrollTop
            // create an array woth positon of each items
            let elementsPositions = []
            this.items.forEach((i, index) => {
                elementsPositions.push({id: i.id, scrollTop: document.querySelector('#element-'+index).offsetTop})
            })
            // find the position of the scrolled item and select it
            elementsPositions.forEach((i,index) => {
                if(elementsPositions[index+1] != undefined) {
                    if(scrollTop > i.scrollTop && scrollTop < elementsPositions[index+1].scrollTop) {
                        this.selectedId = elementsPositions[index+1].id
                        this.items[index].title_2 ? _this.nb_column = 2 : _this.nb_column = 1
                    }
                }
            })

        },

        mouseOverElement(element,index) {
            // select the right item on scroll
            if(!this.isModalOpen){
                if(this.selectedId === element.id) {
                    return
                } else {
                    this.selectedId = element.id;
                    if((element.title_2 != null && element.title_2 != '') || (element.message_2 != null && element.message_2 != '')){
                        this.nb_column = 2
                    } else {
                        this.nb_column = 1
                    }
                }
            }
        },

        deleteElement(){
            // delete an item
            this.editedElement.id = null;
            let elementIndex = this.items.findIndex((el)=>el.id === this.selectedId);
            this.items.splice(elementIndex,1);
            if (this.selectedId === 0){
                this.updatePositions();
            } else {
                this.axios.delete(`/api/${this.selectedPage}/${this.selectedId}`)
                    .then(response => {
                        this.updatePositions();
                        this.$store.dispatch('updateSingleData', { key:this.selectedPage+'_count', value:this.$store.state.single.data[this.selectedPage+'_count']-1})
                    });
            }
            this.confirmRemove = false;
        },

        copyElementToEdition(element) {
            // create a copy of the element that we want update
            this.editedElement = {
                user_id :element.user_id,
                product_id: element.product_id,
                id: element.id,
                title: element.title,
                title_2: element.title_2,
                message: element.message,
                message_2: element.message_2,
                type: element.type,
                files: element.files,
                position: element.position
            };
        },

        setEditedElement(element) {
            // set an element to edition
            if ( !this.editedElement || this.editedElement.id !== null) {
                alert("element deja en cours d'edition ou de création");
            }
            else {
                if (element.symbol_id > 0){
                        this.isModalOpen = true;
                        this.$eventHub.$emit('open-modal2', Unlink,{symbol_id: element.symbol_id, request_id : element.id });
                } else {
                    let index = this[this.selectedPage].findIndex(el => el.id == element.id)
                    var container = this.$el.querySelector("#scroll-container")
                    container.scrollTop = this[this.selectedPage].length > 0 ? container.scrollHeight / this[this.selectedPage].length * index : 0
                    this.copyElementToEdition(element);
                }
            }
        },

        unsetEditedElement() {
            this.check_if_error = false;
            if (this.editedElement.id === 0){
                this.deleteElement({id:0});
            }
            // delete files imported but not saved
            if(this.$_.find(this.items, i => i.id == this.editedElement.id)){
                this.$_.find(this.items, i => i.id == this.editedElement.id).files = this.$_.dropWhile(this.$_.find(this.items, i => i.id == this.editedElement.id).files, function(f) { return !f.id })
            }

            this.editedElement = {id:null};
        },

        updateElement(elementToModify, element) {
            elementToModify.message = element.message
            elementToModify.message_2 = element.message_2
            elementToModify.title = element.title
            elementToModify.title_2 = element.title_2
            elementToModify.type = element.type
        },

        saveElement(element, LinkFile = false){
            if(element.type == 'separator' || (this.valid_title && this.valid_message)) {
                if(this.nb_column == 2 && this.editedElement.message_2 == null){
                    this.error_2 = true
                    this.editedElement.titre_2 ? '' : this.hint_title2 = 'Sur 2 colonnes, le titre ne peux pas être vide'
                    this.editedElement.message_2 ? '' : this.hint_message2 = 'Sur 2 colonnes, le message ne peux pas être vide'
                } else {
                    this.loading = true
                    this.error_2 = false
                    this.check_if_error = false;
                    let data = {
                        user_id :element.user_id,
                        product_id :element.product_id,
                        message :element.message,
                        message_2 :element.message_2,
                        title :element.title,
                        title_2 :element.title_2,
                        type :element.type,
                        position: element.position
                    }
                    // to upload photos as file when validate
                    let updatePhotoRec =(files,elementId,index)=>{
                        if (index < element.files.length){
                            let file = element.files[index];
                            if (file.toUpdate){
                                let data = new FormData();
                                    data.append('file',file.file);
                                    data.append('file_type',null);
                                    data.append('location',file.pivot.location);
                                    data.append('size', 750);
                                if (file.id > 0){
                                    this.axios.delete(`/api/${this.selectedPage}/${elementId}/file/${file.id}`)
                                        .then(response => {
                                            this.axios.post(`/api/${this.selectedPage}/${elementId}/file`,data)
                                                .then(response => {
                                                    updatePhotoRec(files,elementId,++index)
                                                    this.loading = false
                                                });
                                            });
                                } else {
                                    this.axios.post(`/api/${this.selectedPage}/${elementId}/file`,data)
                                        .then(response => {
                                            updatePhotoRec(files,elementId,++index)
                                            this.loading = false
                                        });
                                }
                            } else {
                                updatePhotoRec(files,elementId,++index)
                            }
                        } else {
                            this.axios.get(`/api/${this.selectedPage}/${elementId}?embed=user,files`)
                                .then(response => {
                                    let elementIndex = this.items.findIndex((el)=>el.id === elementId);
                                    this.items[elementIndex] = response.data;
                                    this.items.sort((el1,el2)=> el1.position - el2.position);       //force recompute
                                    this.updatePositions();  //force recompute
                                    this.loading = false
                            });
                        }
                    }
                    if (element.id === 0) {
                        this.axios.post(`/api/${this.selectedPage}`,data)
                            .then(response => {
                                let elementIndex = this.items.findIndex((el)=>el.id === 0);
                                this.items[elementIndex].id = response.data.id;
                                this.updateElement(this.items[elementIndex], element);
                                this.$store.dispatch('updateSingleData', { key:this.selectedPage+'_count', value:this.$store.state.single.data[this.selectedPage+'_count']+1})
                                updatePhotoRec(this.items[elementIndex].files,response.data.id,0);
                                if(LinkFile == true) {
                                    this.loading_file = true
                                    this.$refs.modal.open(this.selectedPage,response.data.id)
                                    this.loading = false
                                }
                            });
                    } else {
                        this.axios.put(`/api/${this.selectedPage}/${element.id}`,data)
                            .then(response => {
                                let elementToModify = this.items.find((el)=> {
                                    return el.id === element.id
                                });
                                this.updateElement(elementToModify, element);
                                updatePhotoRec(elementToModify.files,elementToModify.id,0);
                                if(LinkFile == true) {
                                    this.loading_file = true
                                    this.$refs.modal.open(this.selectedPage,elementToModify.id)
                                    this.loading = false
                                }
                            });
                    }
                    this.editedElement = {id:null}
                }
            } else {
                this.check_if_error = true;
                this.$eventHub.$emit('open-snackar', 'Les champs ne sont pas valides', 'error')
            }
        },

        onFileChange(evt,elementId,fileIndex,col){
            // when click input add image
            this.display = false
            let col_new = evt.target.id.split('-')[1]
            let element = this.items.find((el)=>el.id === elementId)
            if (fileIndex >= 0){
                element.files[fileIndex].path = URL.createObjectURL(evt.target.files[0])
                element.files[fileIndex].file = evt.target.files[0]
                element.files[fileIndex].toUpdate = true
                element.files[fileIndex].pivot = { file_type:null,location:'area-'+col }
            } else {
                element.files.push({
                    path:URL.createObjectURL(evt.target.files[0]),
                    file:evt.target.files[0],
                    toUpdate:true,
                    pivot: {
                        file_type:null,
                        location:'area-'+col_new
                    }
                })
            }
            this.display = true

        },

        addImgPath(file) {
            return require('../../../assets/img/addimg.svg')
        },

        setColumnNumber(nb_column) {
            if(this.editedElement.title_2 != '' && this.editedElement.title_2 != null){
                if(this.nb_column == 2) {
                    this.confirmRemove2 = true
                } else {
                    this.nb_column = nb_column
                }
            } else if(this.editedElement.message_2 != '' && this.editedElement.message_2 != null){
                if(this.nb_column == 2) {
                    this.confirmRemove2 = true
                } else {
                    this.nb_column = nb_column
                }
            } else {
                this.nb_column = nb_column
            }
        },

        deleteCol(id){
            if(id != 0) {
                this.axios.put(`/api/${this.selectedPage}/${id}`,{
                    message_2: null,
                    title_2: null
                })
                .then(response => {
                    this.editedElement.message_2 = null
                    this.editedElement.title_2 = null
                    this.confirmRemove2 = false
                    this.nb_column = 1
                })
            } else {
                this.editedElement.message_2 = null
                this.editedElement.title_2 = null
                this.confirmRemove2 = false
                this.nb_column = 1
            }
        },

        isCol(number) {
            return (this.nb_column === number);
        },

        clickAdd() {
            if(this.selectedPage === 'requests') {
                this.openAddMenu();
            } else {
                this.addNewItem();
            }
        },

        openAddMenu(){
            this.isMenuOpen = !this.isMenuOpen;
        },

        addItemFromSymbol(){
            this.isMenuOpen = false;
            this.isModalOpen = true;
            this.$eventHub.$emit('open-modal2', ImportSymbol, {product_id: this.params.product_id, position: this.items.length + 1});
        },

        addNewItem(separator = false){
            let request_type = separator ? 'separator' : 'all'
            this.isMenuOpen = false;
            if (this.items.findIndex((el)=>{return el.id === 0} ) >= 0 ){
                this.loading = false
                return;
            }
            this.items.splice(this.items.length,0,{
                id:0,
                position: this.items.length+1,
                files :[],
                product_id :this.params.product_id,
                user:this.$store.state.auth.user,
                user_id:this.$store.state.auth.user.id,
                message :'',
                message_2 :'',
                type : request_type,
                title :'',
                title_2 :'',
                created_at : new Date().toISOString()
            });

            this.copyElementToEdition(this.items[this.items.length - 1])
            setTimeout(() => {
                this.selectItem(this.items[this.items.length - 1], this.items.length-1);
            },20)

        },

        goTo(page){
            if (this.items.length > 0){
                this.selectedId = this.items[0].id;
            }

            this.elementsPositions = []
            this.items.forEach((i, index) => {
                this.elementsPositions.push({id: i.id, scrollTop: document.querySelector('#element-'+index).offsetTop})
            })
        },

        moveUp(element){
            // when draggable element is move up
            let elementId =  this.items.findIndex((el)=>el.id === element.id);
            if (elementId > 0){
                let temp =  this.items[elementId];
                this.items[elementId] =  this.items[elementId-1];
                this.items[elementId-1] = temp;
                this.updatePositions();
                this.items = this.items.sort((el1,el2)=> el1.position - el2.position);
                this.selectItem(this.items[elementId-1], elementId-1);
            }
        },

        moveDown(element){
            // when draggable element is move down
            let elementId = this.items.findIndex((el)=>el.id === element.id);
            if (elementId >= 0 && elementId <  this.items.length -1){
                let temp = this.items[elementId];
                this.items[elementId] = this.items[elementId+1];
                this.items[elementId+1]  = temp;
                this.updatePositions();
                this.items = this.items.sort((el1,el2)=>el1.position -el2.position);
                this.selectItem(this.items[elementId+1], elementId+1);
            }
        },

        onMove(evt){
            // when draggable element is move
            this.isDragging = false;
            this.updatePositions();
            let elementId =  this.items.findIndex((el)=>el.id === this.selectedId)
            this.selectItem(this.items[elementId], elementId);
            return true;
        },

        updatePositions(){
            for (var i = 0 ; i < this.items.length ;i++){
                this.items[i].position = i + 1;
            }
            let updateRec =(array,index)=>{
                if (array.length > index){
                    if (array[index].id > 0){
                        this.axios.put(`/api/${this.selectedPage}/${array[index].id}`,{position :array[index].position})
                            .then(response => {
                                updateRec(array,++index);
                            });
                    } else {
                        updateRec(array,++index);
                    }
                }
            }
            updateRec(this.items,0);
        },

        isTitleError() {
            return this.check_if_error && !this.valid_title;
        },

        isMessageError() {
            return this.check_if_error && !this.valid_message;
        },

        onClose() {
            if(this.params.store_path) {
                this.$store.dispatch('updateSingleData', { key:this.params.store_path, value:this.items })
            }
            this.$eventHub.$emit('close-modal');
            this.$eventHub.$emit('reload-list');
            this.$router.push({name: this.$route.name});

        },

        getDataFromApi() {
            // get requests & comment linked to the product ids
            this.axios.get(`/api/requests?filters=product_id|=|${this.params.product_id}&embed=user,files,symbol.files&order=position|ASC`)
                .then(response => {
                    this.requests = response.data
                    this.requests.forEach((el)=>{
                        if(el.symbol_id > 0 && el.symbol != null) {
                            let symbol_from = el.symbol
                            symbol_from.message ? el.message = symbol_from.message : el.message = null
                            symbol_from.message_2 ? el.message_2 = symbol_from.message_2 : el.message_2 = null
                            symbol_from.title_2 ? el.title_2 = symbol_from.title_2 : el.title_2 = null
                            symbol_from.title ? el.title = symbol_from.title : el.title = null
                            symbol_from.files ? el.files = symbol_from.files : el.files = []
                        }
                    })
                    this.axios.get(`/api/comments?filters=product_id|=|${this.params.product_id}&embed=user,files&order=position|ASC`)
                        .then(response => {
                            this.comments = response.data
                            if(this.params.create_query) {
                                this.addNewItem();
                            }
                            else if(this.params.id!==undefined &&  this.params.element_type!==undefined) {

                                let indexElementInput = this.items.findIndex((el)=>{
                                    return el.id === this.params.id
                                });

                                this.selectItem(this.items[indexElementInput], indexElementInput);
                            }
                        })
                })
        },
        onValidate(){
            this.saveElement(this.editedElement)
            if(this.params.store_path) {
                this.$store.dispatch('updateSingleData', { key:this.params.store_path, value:this.items })
            }
            this.$eventHub.$emit('close-modal');
            this.$eventHub.$emit('reload-list');
        }
    },

    created() {
        this.getDataFromApi();

        if(this.params.element_type!==undefined) {
            if(this.params.element_type==='comment') {
                this.selectedPage = 'comments';
            }
            else if(this.params.element_type==='request'){
                this.selectedPage = 'requests';
            } else {
                console.log('the element type should be comment or request');
            }
        }
        this.product_name = this.params.product_label;

        this.$eventHub.$on('go-to-request', params => {

            this.axios.get(`/api/requests?filters=product_id|=|${this.params.product_id}&embed=user,files,symbol.files&order=position|ASC`)
                .then(response => {
                    this.requests = response.data
                    this.requests.forEach((el)=>{
                        if(el.symbol_id > 0 && el.symbol != null) {
                            let symbol_from = el.symbol;
                            symbol_from.message ? el.message = symbol_from.message : el.message = null
                            symbol_from.message_2 ? el.message_2 = symbol_from.message_2 : el.message_2 = null
                            symbol_from.title_2 ? el.title_2 = symbol_from.title_2 : el.title_2 = null
                            symbol_from.title ? el.title = symbol_from.title : el.title = null
                            symbol_from.files ? el.files = symbol_from.files : el.files = []
                        }
                    });

                    let indexElementInput = this.items.findIndex((el)=> el.id === params.id)

                    setTimeout(() => {
                        this.selectItem(this.items[indexElementInput], this.items.length - 1);
                    },20)

                    this.isModalOpen = false
                })
        })
    },
    mounted(){
        if(this.params.hide_demand) {
            this.show_demand = false
        }
        this.loading = true
    },

}
</script>

<style lang="stylus" scoped>
    @require '../../../assets/css/variables'
    .loader
        display flex
        flex-direction column
        align-items center
        justify-content center
        height 90%
        width 100%
        padding 3rem 0

        img
            margin 0 0 3rem
    .files {
        label {
            font-size: 1.6rem
            height: 100%
            width: 100%
            display: flex
            align-items: center
            cursor: pointer
        }
    }
    $header-hight = 60px
    $aside-width = 317px
    $content-margin = 115px
    .overlay {
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center
        .overlay-container{
            z-index: 4
            display: flex
            flex-direction: column
            align-items: center
            justify-content: center
            width: 50%
            height:  50%
            .overlay-image {
                max-width: 50%
                max-height:  50%
            }
        }
        position: fixed
        top: 0
        left: 0
        width: 100%
        height: 100%
        z-index: 10
        background-color: rgba(0,0,0,0.5)
    }
    .is-editing {
        overflow :hidden
    }
    .comments-contents {
        position: absolute
        top: $header-hight
        bottom: 0
        left: $aside-width
        width: 'calc(100vw - %s)' % $aside-width
        margin: 0
        padding: 0
        height: calc(100vh-128px)

        .content-item {
            padding: 0
            padding: 0
            position: relative
            height: calc(100vh - 6rem)

            .full-element-container {
                position: relative;
                margin: 0
                padding: 0
                height: 100%
                width: 'calc(100vw - %s - 15px)' % $aside-width
                overflow-y: scroll
                &::-webkit-scrollbar { width: 0 !important }
                input {
                    display: none;
                }

                 & >>> .alert {
                     padding: 0.5rem 2rem;
                     width: 95%
                     margin-top: 3rem
                 }
                    .content-toolbar {
                        display:flex
                        align-items: center
                        width: 'calc(100% - (%s * 2))' % $content-margin !important
                        padding-top: 3rem
                        margin-left: $content-margin

                        button.btn {
                            height:36px
                        }

                        .type-color-round {
                            margin-left: -18px
                            margin-top:27px
                            z-index: 2
                        }
                        .contain-type-select {
                            max-width: 120px
                        }
                        .user-name-container {
                            margin-left: 15px
                            .writing-mode {
                                color: #999
                            }
                        }
                    }


                .center-content {
                    margin-top: 45px
                    margin-left: $content-margin
                    height: calc(100% - 32rem)
                    overflow-y: scroll

                    &::-webkit-scrollbar { width: 0 !important }

                    .title-row{
                        max-height: 80px !important
                    }

                    .img-layout {
                        padding: 0 3rem
                    }

                    .edit-title {
                        margin-bottom: 0  !important
                        margin-top: 0  !important
                        margin: 2rem !important
                        border-color: black !important
                        border-width: 10px !important
                        border-radius: 8px !important
                        font-size: 50px !important
                        max-height: 80px !important
                    }

                    .comment-title {
                        padding-bottom: 50px
                        font-size: 3rem
                        font-weight: 600
                        line-height: 3rem
                    }

                    .edit-message {
                        margin-bottom: 0
                        margin: 2rem !important
                        margin-top: 0 !important
                        border-color: black !important
                        border-width: 10px !important
                        border-radius: 8px !important
                        font-size: 50px !important
                    }

                    .comment-message {
                        width: 100%
                        padding-bottom: 0
                        font-size: 1.7rem
                        margin-bottom: 2rem
                    }

                    .on-left {
                        padding-right: 1rem
                    }
                    .on-right {
                        padding-left: 1rem
                    }

                    .comment-image {
                        margin-top: 25px
                        height: 150px
                        width: 150px
                        margin-bottom: 10px
                        background-color: rgba(0,0,0,0.68)
                        cursor: pointer
                        display: block
                        img {
                            width:100%
                            height:100%
                            object-fit: contain
                            background-color: #FFF
                            &.add-img {
                                padding: 40px !important
                                background-color: rgba(0, 0, 0, 0.5)
                            }
                        }
                        .hover-alpha {
                            height: 100%
                            width: 100%
                            position: absolute
                            margin-bottom: 35px
                            &:not(hover) {
                                background-color: rgba(0, 0, 0, 0);
                                color: rgba(0, 0, 0, 0);
                            }
                            &:hover {
                                background-color: rgba(0, 0, 0, 0.5);
                                color: white;
                            }
                        }
                    }

                    .comment-no-image {
                        height: 150px
                        width: 150px
                        margin-bottom: 35px
                    }


                }
                .files-list-container {
                    padding: 1rem 1.5rem
                    position: relative
                    margin-top: 15px
                    background: #eee
                    font-size: 1.7rem
                    border-radius: 5px
                    border-width: 2px
                    border-color: blue
                    width: 'calc(100% - (%s * 2) + 2rem)' % $content-margin
                    color: $primary-color
                    display: inline-flex
                    font-weight: bold
                    align-items: center
                    cursor: pointer
                    .files-list-container-title {
                        font-style: italic
                        color: black
                        padding-right: 1rem
                        font-weight: normal
                    }
                }
            }
            .col-choice-title {
                height: 15px
                font-size: 1rem
            }
            .column-display-choice {
                padding: 1.5rem 5rem
                position: absolute
                bottom: 0
                left: 0
                background: white
                font-size: 2rem
                width: 100%
                height: 9rem
                align-items: center
                cursor: pointer
                z-index: 10
                .column-display-buttons{
                    display: inline-flex
                    position: relative
                    top: 0
                    left: 0
                    .image-and-overlay-left {
                        position: relative
                        bottom: 25px
                        left: 0
                    }
                    .image-and-overlay-right {
                        position: relative
                        bottom: 25px
                        left: 80px
                    }
                    .col-chose-image {
                        position: absolute
                        top: 0
                        left: 0
                        width:70px
                        height: 35px
                        margin: 10px
                        margin-top: 5px
                        margin-left:0
                        padding: 0
                    }
                    .col-choice-overlay {
                        position: absolute
                        top: 0
                        left: 0
                        width:70px
                        height 35px
                        background: rgba(252,225,255,0.5);
                        box-shadow: 0 8px 18px 0 rgba(253,232,255,1);
                        border-radius: 10px;
                        margin: 10px
                        margin-top: 5px
                        margin-left:0
                        z-index:10
                    }
                }
            }
        }
    }

    .modal-header {
        display:flex
        justify-content: flex-start
        align-items center
        z-index: 2
        height: $header-hight
        background: white
        box-shadow: 0 0 33px 0 #EBEFF5 !important

        div.app-logo {
            height: $app-nav-width
            display: flex
            align-items:center
            justify-content:center
            border-right: 1px solid $border-light-color
            border-bottom: 1px solid $border-light-color
            padding: 0 2.5rem

            img {
                max-width: 100%
            }
        }

        & >>> button.btn {
            padding: 0
            margin:0
            min-width: auto
            height: 100%
        }

    }
    .comments-aside {
        z-index: 1
        position: fixed;
        top: $app-header-height
        bottom: 0
        left: 0
        width: $aside-width
        padding: 0
        margin: 0
        box-shadow: inset -1px -1px 0 0 #ECEFF5, 15px 2px 21px 0 #FAFAFC;
        a {
            text-decoration:none;
        }
        .tab {
            .tabs {
                .tabs__bar {
                    & >>> .tabs__li a{
                              text-transform: none
                              color: $text-color
                              font-size: 1.5rem
                              font-weight: 700
                              &.tabs__item {
                                  color: #D4DCE5!important;

                                  &.tabs__item--active {
                                       color: $primary-color !important;
                                  }
                              }
                          }
                }
            }
        }
    }
    .draggable-container{
        margin :0
        padding:0
        height :calc(100vh - 200px)
    }
    .v-tabs-title{
        height :60px
        margin-bottom: 30px
    }
    .add-footer{
        position: fixed
        bottom:0
        left:0
        width: $aside-width !important
        box-shadow-color:$box-shadow-color
        color: $primary-color

        .menu-button {
            color: $primary-color
            margin: 0
            padding: 0
            box-shadow: none
            width: 100%
            height:90px
            background: white!important

            & >>> .btn__content {

                font-size: 18px
                      i {
                          margin: 10px
                          color :$primary-color
                      }
            }
            &.active {
                opacity: 0.24;
                &:hover {
                    opacity: 1
                }
            }

        }
    }
    .add-menu {
        box-shadow-color:$box-shadow-color
        box-shadow:-18px -5px 29px -15px
        color : #ABB4D0
        background-color:white
        position: absolute
        width: $aside-width
        bottom: 90px
        .add-menu-header{
            margin-top 12px
           margin-bottom: 30px
            margin-left: 42px
            font-size: 12px
            font-style: italic
            font-weight: 600
        }
        .add-menu-item{
            color : $primary-color
            & > .menu-button {
                height: 60px
            }
            & > button >>> .btn__content {
                display:flex
                justify-content:flex-start
            }
            & > button >>>.btn__content > i {
                margin: 10px 40px
            }
        }
    }
    .current-item{
        background-color: $primary-color
        color:white !important
        .item-draggable-date {
            font-style:italic
            color:#9847A0 !important
        }
        .item-draggable-line {
            width:10px;
            background: #9847A0 !important
        }
    }

    .item-draggable{
        color: black
        .item-draggable-action{
            display: none
            width: 40px
            margin-top: 12px
        }
        &:hover {
            .item-draggable-action{
                display: block
            }
        }
        .item-draggable-position {
            width :5px
            margin-bottom: 7px
            margin-left: 7px
        }
        .item-draggable-avatar{
            width :70px
            display: flex
            align-items: flex-end
            font-size:1.2rem
            margin-right: 12px
            .aside-type-color-round {
                margin-left: -30px !important
                margin-bottom: 5px !important
                z-index: 2
            }
        }
        .item-draggable-image{
            margin:10px
        }
        .item-draggable-text{
            width: 100px
        }
        .item-draggable-title {
            display:block;
            font-size:2rem
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 200%;
            &.bold {
                font-weight: bold
            }
        }
        .item-draggable-user {
            font-size:1.2rem
        }
        .item-draggable-line {
            margin:8px
            width:15px;
            background: #ABB4D0
            height:1px;
        }
        .item-draggable-date {
            display:flex
            font-size:1.2rem
            color:#ABB4D0
        }
    }
    .ghost {
        border: 2px dashed #D4DCE5
        border-radius: .5rem
        background-color: #EDF3FA
        div {
            opacity: 0
        }
    }


    .dialog {

        letter-spacing: -0.4px
        .card {
            .card__title {
                justify-content: space-between
                padding: 1.5rem 2rem
                background: $primary-light-color

                h2 {
                    display: flex
                    align-items: center
                    margin: 0
                    color: #fff
                    font-size: 1.8rem
                    font-weight: 500

                    .icon {
                        margin: 0 1.5rem 0 0
                        font-size: 3rem
                        color: #fff !important
                    }
                }
                button {
                    margin: 0

                    .icon {
                        font-size: 2rem
                        color: #fff
                    }
                }
            }
            .card__actions {
                padding:20px 15px;
            }
        }
        @media screen and (max-width: 900px){
            .modal-header {
                position: fixed
                width: 100%
            }
            .comments-aside {
                display: none
            }
            .comments-contents {
                position: inherit
                width: 100%
                .full-element-container {
                    width: 100%
                    .alert {
                        margin-top: 7rem
                    }
                    .content-toolbar{
                        padding-top: 5rem
                    }
                    .center-content {
                        margin: 4rem 10rem
                        &.doublecol {
                            .read {
                                flex-direction: column
                                .flex {
                                    &:last-of-type{
                                        position: relative
                                        top: 40rem
                                    }
                                }
                            }
                            form{
                                .layout {
                                    flex-direction: column
                                    .edit-title {
                                        &:last-of-type{
                                            position: relative
                                            top: 40rem
                                        }
                                    }
                                    .edit-message {
                                        &:last-of-type{
                                            position: relative
                                            top: 33rem
                                        }
                                    }
                                }
                                &:last-of-type{
                                    height: 17%
                                }
                            }
                            .d-flex.imgs {
                                flex-direction: column
                                .flex {
                                    &:last-of-type{
                                        position: relative
                                        top: 30rem
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/products/single/CreateComment.vue